import CancelButton from './CancelButton';
import SaveButton from './SaveButton';

const CancelSaveButtonGroup = ({
  onCancel,
  onSave,
  cancelButtonDisabled = false,
  saveButtonDisabled = false,
  ...props
}) => {
  const cancelButtonProps = {
    type: 'secondary',
    style: {marginRight: '10px'},
    onClick: onCancel,
    ...props,
  };

  const saveButtonProps = {
    loading: onSave,
    type: 'primary',
    ...props,
  };

  return (
    <div>
      <CancelButton {...cancelButtonProps} disabled={cancelButtonDisabled}/>
      <SaveButton {...saveButtonProps} disabled={saveButtonDisabled}/>
    </div>
  );
};

export default CancelSaveButtonGroup;
